<script>
    import R from "../../lib/requests";
    import {clickOutside} from '../../lib/clickOutside.js';
    import {createEventDispatcher} from 'svelte/internal';
    import AppIcon from "../icons/AppIcon.svelte";
    import ControlLoader from "../ControlLoader.svelte";

    export let department = null;
    export let placeholder = '';
    export let css = '';
    export let disabled = false;

    let departmentId = null;
    let name = '';
    let timer;
    let results = [];
    let listIndex = -1;
    let showDropdown = false;
    let showNotFound = false;
    let loading = false;

    const dispatch = createEventDispatcher();

    const search = () => {
        const onSuccess = result => {
            results = result;
            loading = false;
            showNotFound = results.length === 0;
            openDropdown();
        }

        const onFailure = err => {
            loading = false;
        };

        loading = true;
        R.handle(R.department.index, {name}, onSuccess, onFailure);
    }

    const onFocusOut = () => {
        if (department) {
            name = department.name;
        }
    }

    const onKeyDown = (event) => {
        if (results && results.length) {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                listIndex++;
                if (listIndex >= results.length) {
                    listIndex = 0;
                }
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                listIndex--;
                if (listIndex < 0) {
                    listIndex = results.length - 1;
                }
            } else if (event.key === 'Enter') {
                event.preventDefault();
                if (timer) {
                    clearInterval(timer);
                }
                if (listIndex > -1) {
                    onSelect(results[listIndex]);
                } else {
                    closeDropdown();
                }
            } else if (event.key === 'Escape') {
                closeDropdown();
            }
        }
    }

    const onKeyUp = (event) => {
        if (name != event.target.value) {
            showNotFound = false;
            name = event.target.value;
            if (timer) {
                clearInterval(timer);
            }

            if (name.length) {
                timer = setInterval(() => {
                    clearInterval(timer);
                    search();
                }, 500);
            } else {
                clear();
            }
        }
    }

    const clear = () => {
        department = null;
        departmentId = null;
        showNotFound = false;
        dispatch("change");
    }

    const onSelect = (item) => {
        department = item;
        name = department.name;
        dispatch("change", department);
        closeDropdown();
    }

    const openDropdown = () => {
        showDropdown = true;
    }

    const closeDropdown = () => {
        showDropdown = false;
    }

    $: {
        if (department) {
            if (departmentId != department.id) {
                departmentId = department.id;
                name = department.name;
            }
        } else {
            if (departmentId != null && !department) {
                departmentId = null;
                name = '';
            }
        }
    }
</script>

<div class="dropdown-container" use:clickOutside on:click_outside="{ closeDropdown }">
    <input type="text" class="form-control {css}" id="departmentName" value="{ name }" on:keydown="{ onKeyDown }" on:keyup="{ onKeyUp }"
           on:focusout="{ onFocusOut }"
           autocomplete="off" {disabled}
           {placeholder}>

    {#if showNotFound}
        <div class="not-found">
            <AppIcon icon="circle-exclamation-solid" size="16"/>
        </div>
    {/if}
    <ControlLoader {loading}/>

    {#if showDropdown}
        {#if results.length}
            <ul class="dropdown">
                {#each results as item, index}
                    <li class="dropdown-item pointer" class:selected="{ listIndex === index }"
                        on:click="{ () => onSelect(item) }">
                        { item.name }
                    </li>
                {/each}
            </ul>
        {/if}
    {/if}
</div>

<style>
    .not-found {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        color: rgba(255, 0, 0, 0.5);
    }
</style>